// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pwButton {
    margin-bottom: 1.25em;
    align-self: flex-start;
}

.help-block {
    color: red;
    font-size: small;
    line-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/user/user.provider.settings.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".pwButton {\n    margin-bottom: 1.25em;\n    align-self: flex-start;\n}\n\n.help-block {\n    color: red;\n    font-size: small;\n    line-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
